const DEFAULT_DESTINE_PROVIDER_ALIASES = ['destine', 'destine-iam', 'destine_iam'];

function getRuntimeConfig() {
  return typeof window !== 'undefined' ? window.__RUNTIME_CONFIG__ || {} : {};
}

function getDestineProviderAliases() {
  const raw = getRuntimeConfig().REACT_APP_DESTINE_IAM_PROVIDER;
  if (!raw || typeof raw !== 'string') return DEFAULT_DESTINE_PROVIDER_ALIASES;
  return raw
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

function normalizeProviderId(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, '-');
}

export function isDestineIamProvider(providerName, displayName) {
  const aliases = getDestineProviderAliases();
  const candidates = [providerName, displayName].map(normalizeProviderId).filter(Boolean);
  return candidates.some(
    (id) =>
      aliases.includes(id) ||
      id.includes('destine') ||
      aliases.some((alias) => id.includes(alias))
  );
}

function buildAccountApiUrl(keycloak, path) {
  const base = (keycloak.authServerUrl || '').replace(/\/$/, '');
  const realm = keycloak.realm;
  return `${base}/realms/${realm}/account/${path}`;
}

export async function fetchLinkedAccounts(keycloak) {
  if (!keycloak?.token) return [];

  const urls = [
    buildAccountApiUrl(keycloak, 'linked-accounts'),
    buildAccountApiUrl(keycloak, 'linkedAccounts'),
  ];

  for (const url of urls) {
    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${keycloak.token}`,
          Accept: 'application/json',
        },
      });
      if (!response.ok) continue;
      const data = await response.json();
      return Array.isArray(data) ? data : [];
    } catch {
      // try next endpoint shape
    }
  }

  return [];
}

export function getDestineIamFromToken(tokenParsed) {
  if (!tokenParsed) {
    return { signedInViaDestine: false, sessionProvider: null };
  }

  const sessionProvider = tokenParsed.identity_provider || tokenParsed.idp || null;
  const issuerSuggestsDestine =
    typeof tokenParsed.iss === 'string' && tokenParsed.iss.toLowerCase().includes('destine');

  const signedInViaDestine =
    (typeof sessionProvider === 'string' &&
      isDestineIamProvider(sessionProvider, sessionProvider)) ||
    issuerSuggestsDestine;

  return { signedInViaDestine, sessionProvider };
}

export async function getDestineIamLinkStatus(keycloak) {
  const tokenParsed = keycloak?.tokenParsed;
  const { signedInViaDestine, sessionProvider } = getDestineIamFromToken(tokenParsed);

  const linkedAccounts = await fetchLinkedAccounts(keycloak);
  const destineAccount = linkedAccounts.find((account) =>
    isDestineIamProvider(account.providerName, account.displayName || account.providerName)
  );

  if (destineAccount) {
    return {
      linked: true,
      linkedUsername: destineAccount.linkedUsername || destineAccount.userName || null,
      providerName: destineAccount.providerName || destineAccount.displayName || null,
      signedInViaDestine,
      sessionProvider,
      statusKnown: true,
    };
  }

  return {
    linked: signedInViaDestine,
    linkedUsername: signedInViaDestine ? tokenParsed?.preferred_username || tokenParsed?.email : null,
    providerName: sessionProvider,
    signedInViaDestine,
    sessionProvider,
    statusKnown: linkedAccounts.length > 0 || signedInViaDestine,
  };
}
